import DynamicPageRenderer from "../../components/DynamicPageRenderer";

const EcoleTivaouane = () => {
  return <DynamicPageRenderer slug="enseignements/ecole" />;
};

export default EcoleTivaouane;
